import React from 'react';
import { Reveal } from './Reveal';
export function PainSection() {
  return <section className="py-14 px-6" data-id="element-124">
      <Reveal data-id="element-125">
        <span className="inline-block text-[10px] font-semibold tracking-[0.14em] uppercase text-sage mb-3" data-id="element-126">
          ¿Te identificás?
        </span>
        <h2 className="font-serif text-[34px] font-semibold leading-[1.15] text-ink mb-2" data-id="element-127">
          Síntomas que
          <br data-id="element-128" />
          el médico <em className="italic text-terra" data-id="element-129">descarta</em>
        </h2>
        <p className="text-[15px] leading-[1.7] text-ink-soft mb-7" data-id="element-130">
          No estás exagerando. No es estrés. No es la edad. Cada síntoma que
          sentís tiene una hormona detrás.
        </p>

        <div className="grid grid-cols-2 gap-2.5 mt-6" data-id="element-131">
          <div className="bg-cream-dark rounded-xl py-4 px-3.5 flex flex-col gap-2" data-id="element-132">
            <span className="text-[22px]" data-id="element-133">😮‍💨</span>
            <p className="text-[13px] font-medium leading-[1.4] text-ink" data-id="element-134">
              Fatiga que no mejora aunque descanses
            </p>
          </div>
          <div className="bg-cream-dark rounded-xl py-4 px-3.5 flex flex-col gap-2" data-id="element-135">
            <span className="text-[22px]" data-id="element-136">⚖️</span>
            <p className="text-[13px] font-medium leading-[1.4] text-ink" data-id="element-137">
              Peso que no baja aunque te cuidés
            </p>
          </div>
          <div className="bg-cream-dark rounded-xl py-4 px-3.5 flex flex-col gap-2" data-id="element-138">
            <span className="text-[22px]" data-id="element-139">🌀</span>
            <p className="text-[13px] font-medium leading-[1.4] text-ink" data-id="element-140">
              Ansiedad e irritabilidad sin causa
            </p>
          </div>
          <div className="bg-cream-dark rounded-xl py-4 px-3.5 flex flex-col gap-2" data-id="element-141">
            <span className="text-[22px]" data-id="element-142">🌙</span>
            <p className="text-[13px] font-medium leading-[1.4] text-ink" data-id="element-143">
              Insomnio o sueño no reparador
            </p>
          </div>
          <div className="bg-cream-dark rounded-xl py-4 px-3.5 flex flex-col gap-2" data-id="element-144">
            <span className="text-[22px]" data-id="element-145">🧠</span>
            <p className="text-[13px] font-medium leading-[1.4] text-ink" data-id="element-146">
              Niebla mental y falta de concentración
            </p>
          </div>
          <div className="bg-cream-dark rounded-xl py-4 px-3.5 flex flex-col gap-2" data-id="element-147">
            <span className="text-[22px]" data-id="element-148">📅</span>
            <p className="text-[13px] font-medium leading-[1.4] text-ink" data-id="element-149">
              Ciclo irregular o SPM intenso
            </p>
          </div>
        </div>

        <div className="bg-ink rounded-2xl p-6 mt-7" data-id="element-150">
          <p className="font-serif text-[22px] font-light italic leading-[1.4] text-white" data-id="element-151">
            "Mis análisis están bien. Pero yo no estoy bien."
          </p>
          <span className="block mt-3 text-[12px] text-white/40 font-sans" data-id="element-152">
            — La frase que dicen miles de mujeres cada semana
          </span>
        </div>
      </Reveal>
    </section>;
}